import { useState } from 'react';
import { Sparkles } from 'lucide-react';

const MODEL = { service: 'service business', digital: 'digital product business', consulting: 'consulting practice', physical: 'product brand', other: 'business' };
const PHRASES = [
  ['pos_customer', 'who it\u2019s for'], ['pos_struggle', 'what they struggle with'], ['pos_help', 'what you help them do'],
  ['pos_alternative', 'what they\u2019d use instead'], ['pos_difference', 'what you do differently'],
];

// Normalizes a short phrase so it reads naturally mid-sentence; the founder's own words are kept.
const phrase = (v, strip = []) => {
  let t = (v || '').trim().replace(/^["'\u201c\u2018]+|["'\u201d\u2019]+$/g, '').replace(/[.!?;:,\s]+$/, '');
  strip.forEach((w) => { t = t.replace(new RegExp(`^${w}\\s+`, 'i'), ''); });
  return /^[A-Z][a-z]/.test(t) ? t[0].toLowerCase() + t.slice(1) : t;
};

export const buildPositioning = (a) => {
  const d = a.define || {};
  const name = (a.discover?.concept_name || '').trim();
  const missing = PHRASES.filter(([k]) => !(d[k] || '').trim()).map(([, label]) => label);
  if (!name) missing.unshift('your business name (Stage 01)');
  if (missing.length) return { missing };
  const type = MODEL[a.discover?.business_model] || 'business';
  const article = /^[aeiou]/i.test(type) ? 'an' : 'a';
  return {
    text: `For ${phrase(d.pos_customer, ['for'])} who struggle with ${phrase(d.pos_struggle, ['struggle with', 'struggling with'])}, `
      + `${name} is ${article} ${type} that helps them ${phrase(d.pos_help, ['to', 'help them', 'helps them'])}. `
      + `Unlike ${phrase(d.pos_alternative, ['unlike'])}, we ${phrase(d.pos_difference, ['we'])}.`,
  };
};

export const PositioningBuilder = ({ answers, onUse }) => {
  const [missing, setMissing] = useState([]);
  const click = () => {
    const r = buildPositioning(answers);
    setMissing(r.missing || []);
    if (r.text) onUse(r.text);
  };
  return (
    <div>
      <button type="button" onClick={click}
        className="mt-2 inline-flex items-center gap-2 rounded-full border border-gold/50 px-4 py-2 text-[11px] uppercase tracking-[0.16em] text-matte hover:bg-gold/10 transition-colors duration-200"
        data-testid="positioning-builder-button">
        <Sparkles size={12} className="text-gold" /> Draft from my answers
      </button>
      {missing.length > 0 && (
        <p className="mt-2 text-sm text-matte/70" data-testid="positioning-builder-missing">
          To draft your statement, first fill in: {missing.join(', ')}.
        </p>
      )}
    </div>
  );
};
